import createCategories from './createCategories';
import createQualities from './createQualities';
import { IFetchMyselfResponseData, IMyselfState } from 'types/myself';

export default function fetchMyselfSuccess(state: IMyselfState, payload: IFetchMyselfResponseData) {
  const {
    character,
    possessions,
  } = payload;

  // Destructure `character`. We're going to replace the mantelpiece and scrapbook
  // qualities with their IDs
  const {
    ...restCharacter
  } = character;

  const mantelpieceItemId = character.mantelpieceItem?.id;
  const scrapbookStatusId = character.scrapbookStatus?.id;

  return {
    ...state,
    hasFetched: true,
    isFetching: false,
    character: {
      ...restCharacter,
      mantelpieceItemId,
      scrapbookStatusId,
    },
    categories: createCategories(possessions),
    qualities: createQualities(possessions),
  };
}